<template>
  <form @submit.prevent="editarOrInsert">
    <header class="w3-container w3-small" style="padding-top:22px">
      <button class="w3-button primary w3-right w3-round" style="margin-left: 12px; width: 150px"><i
        class="fa fa-check"></i> Salvar
      </button>
      <h6><b>Colaboradores</b></h6>
    </header>

    <div style="margin: 0 16px">
      <div class="w3-padding w3-small" style="margin:0 -16px">
        <div class="w3-responsive w3-card w3-white w3-padding-16">
          <div class="w3-row-padding">
            <div class="w3-col l3 w3-margin-top">
              <label><b>Nome</b></label>
              <input type="text" class="w3-input w3-border" placeholder="Nome do colaborador" v-model="dados.nome" required>
            </div>
            <div class="w3-col l3 w3-margin-top">
              <label><b>Usuário</b></label>
              <input class="w3-input w3-border" placeholder="Usuário do colaborador" v-model="dados.usuario" pattern="[a-zA-Z0-9]+" style="text-transform: lowercase">
            </div>
            <div class="w3-col l3 w3-margin-top">
              <label><b>Email</b></label>
              <input type="email" class="w3-input w3-border" placeholder="Email do colaborador" v-model="dados.email">
            </div>
            <div class="w3-col l3 w3-margin-top">
              <label><b>Função</b></label>
              <select class="w3-select w3-border w3-white" v-model="dados.id_funcao">
                <option v-for="f in funcoes" :value="f.id_funcao">{{f.nome_funcao}}</option>
              </select>
            </div>
            <div class="w3-col l3 w3-margin-top">
              <label><b>Senha</b></label>
              <input type="password" class="w3-input w3-border" placeholder="Senha do colaborador" v-model="senha" :disabled="!alterarSenha">
            </div>
            <div class="w3-col l3 w3-margin-top" v-show="editar">
              <label><b>&nbsp;</b></label><br>
              <input id="alterarSenha" type="checkbox" class="w3-check" v-model="alterarSenha">
              <label for="alterarSenha"><b>Alterar Senha</b></label>
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </form>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import MenuDash from "../../commons/MenuDash.vue"
  import {Money} from 'v-money'

  export default {
    components: {TopBar, MenuDash, Money},
    props: {
      editar: false
    },
    data() {
      return {
        token: localStorage.getItem('key'),
        id_colaborador: 0,
        senha: '',
        alterarSenha: false,
        permissoes: [],
        funcoes: [],

        dados: {
          nome: '',
          email: '',
          usuario: '',
          id_funcao: 1,
          permissoes: [],
          fg_ativo: 1,
          senha: 1
        },
      }
    },

    methods: {
      getColaborador() {
        openLoading("Buscando dados");
        let url = base_url + 'usuarios/' + this.token + "/1";
        this.$http.get(url, {params: {id_usuario: this.id_colaborador}}).then(response => {
          if (response.data.result) {
            this.dados = response.data.result;
          }
          closeLoading();
        }, res => {
          closeLoading();
          openModalMsg(res.data.result,res.data.msg);
        });
      },

      editarOrInsert() {
        if (this.alterarSenha) {
          if (this.senha.trim().length < 6) {
            openModalMsg("Atenção!","A senha deve conter no mínimo 6 caracteres");
            return;

          } else {
            this.dados.senha = this.senha;
          }

        } else {
          delete this.dados.senha;
        }

        openLoading("Modificando usuário");
        let url = base_url + "usuarios/inserir/" + this.token;
        if (this.editar) {
           url = base_url + "usuarios/editar/" + this.token;
        }

        this.$http.post(url, this.dados, {emulateJSON: true})
          .then(res => {
            console.log(res);
            closeLoading();
            if (!this.editar) {
              //this.$router.push("/admin/colaboradores/" + res.data.id_usuario);

            } else {
              this.alterarSenha = false;
              this.inicializar();
            }
          },

          res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result ? res.data.result : "Atenção", res.data.msg ? res.data.msg : "Erro interno no servidor!");
          });
      },

      cadastrar() {
        this.$router.push('/admin/colaboradores');
        this.editar = false;
        this.inicializar();
      },

      inicializar() {
        this.buscarFuncao();

        if (this.$route.params.id) {
          this.id_colaborador = this.$route.params.id;
          this.getColaborador();
          this.editar = true;

        } else {
          this.editar = false;
          this.alterarSenha = true;
          this.dados = {
            nome: '',
            email: '',
            usuario: '',
            id_funcao: '1',
            fg_ativo: 1,
            permissoes: []
          }
        }
      },

      buscarFuncao() {
        this.$http.get(base_url + 'funcao-usuario/' + this.token)
          .then(response => {
            this.funcoes = response.data;
            closeLoading();

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      }
    },

    mounted() {
      this.inicializar();
    }
  }
</script>

<style scoped>
  .w3-centered tr td {
    padding: 13px;
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/colaborador/Formulario.vue